import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Auth, user as getUser } from '@angular/fire/auth';
import { UserService } from './user.service';
import { firstValueFrom } from 'rxjs';

export const publicPageWithUserGuard: CanActivateFn = async () => {
  const afAuth = inject(Auth);
  const userService = inject(UserService);

  if (userService.dbUser) {
    return true;
  }

  const currentUser = await firstValueFrom(getUser(afAuth));

  if (currentUser?.emailVerified) {
    await userService.checkAccess(currentUser);
  }

  return true;
};
